import React, { useEffect, useRef, useState } from "react"
import { connect } from "react-redux"

//Import Action to copy breadcrumb items from local state to redux state
import { setBreadcrumbItems } from "../../store/actions"
import SimpleBar from "simplebar-react/dist"
import * as Yup from "yup"
import { useFormik } from "formik"
import {
  Card,
  CardBody,
  Dropdown,
  Col,
  Label,
  Input,
  Form,
  FormFeedback,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  TabContent,
  TabPane,
  Row,
  Button,
  Modal,
  ModalHeader,
  ModalFooter,
  ModalBody,
} from "reactstrap"
import { Link } from "react-router-dom"
import { Alert, Table, Spinner } from "reactstrap"

import axios from "axios"
import config from "config/config"

import { useSelector } from "react-redux"
import Spinners from "components/Common/Spinner"

import UserJPG from "../../assets/images/user.jpg"
import SnackbarComponent from "components/SnackBar"
import { formatDate } from "helpers/date-format"
import CustomerDetailsLeftCard from "./CustomerDetailsLeftCard"
import CustomerDetailsRightCard from "./CustomerDetailsRightCard"
import EditCustomerCard from "./EditCustomerCard"

const CustomerDetails = props => {
  document.title = "Customer Details | AeraVue"
  const [customer, setCustomer] = useState(props.customer)

  const breadcrumbItems = [
    { title: "Dashboard", link: "#" },
    { title: "Customers", link: "/dashboard/customers" },
    { title: `${customer.name}`, link: "#" },
  ]

  useEffect(() => {
    props.setBreadcrumbItems("Customer Details", breadcrumbItems)
  })

  const [singleBtn, setSingleBtn] = useState(false)

  const userData = useSelector(state => state.Login.userData)
  const [isLoading, setLoading] = useState(false)

  // const Chat_Box_Username2 = "Henry Wells"
  const [currentActiveTab, setCurrentActiveTab] = useState("Visits")
  // eslint-disable-next-line no-unused-vars
  const currentUser = {
    name: "Henry Wells",
    isActive: true,
  }
  const [activeTab, setActiveTab] = useState("1")
  // eslint-disable-next-line no-unused-vars
  const [Chat_Box_User_Status, setChat_Box_User_Status] = useState("online")
  const [err, setErr] = useState(null)
  const [success, setSuccess] = useState(null)
  const [visible, setVisible] = useState(true)
  const [editTabVisible, setEditTabVisible] = useState(false)
  const onDismiss = () => setVisible(false)
  const [startDate, setStartDate] = useState("")
  const [endDate, setEndDate] = useState("")
  const [selectedService, setSelectedService] = useState("")
  const [activeDistribution, setActiveDistribution] = useState(null)
  const [distributions, setDistributions] = useState(null)
  const [distributionModalOpen, setDistributionModalOpen] = useState(false)
  const [surveyTitle, setSurveyTitle] = useState("")
  const [responded, setResponded] = useState("")
  const [opened, setOpened] = useState("")
  const [startSurveyDate, setStartSurveyDate] = useState("")
  const [endSurveyDate, setEndSurveyDate] = useState("")
  const [filteredSurveys, setFilteredSurveys] = useState(null)

  const clearSurveyFilters = () => {
    setSurveyTitle("")
    setResponded("")
    setOpened("")
    setStartSurveyDate("")
    setEndSurveyDate("")
    setFilteredSurveys(distributions) // Reset to full list
  }

  const applySurveyFilters = () => {
    const filteredSurveys = distributions.filter(dist => {
      const matchesTitle = surveyTitle
        ? dist.Survey.title.toLowerCase().includes(surveyTitle.toLowerCase())
        : true

      const matchesResponded = responded
        ? responded === "yes"
          ? dist.responded === true
          : dist.responded === false
        : true

      const matchesOpened = opened
        ? opened === "yes"
          ? dist.opened === true
          : dist.opened === false
        : true

      const matchesStartDate = startSurveyDate
        ? new Date(dist.createdAt) >= new Date(startSurveyDate)
        : true

      const matchesEndDate = endSurveyDate
        ? new Date(dist.createdAt) <= new Date(endSurveyDate)
        : true

      return (
        matchesTitle &&
        matchesResponded &&
        matchesOpened &&
        matchesStartDate &&
        matchesEndDate
      )
    })

    setFilteredSurveys(filteredSurveys)
  }

  const toggleModal = () => setDistributionModalOpen(!distributionModalOpen)

  const handleDistributionClick = distribution => {
    setActiveDistribution(distribution)
    toggleModal()
  }

  // Dropdown state
  const [isDropdownOpen, setIsDropdownOpen] = useState(false)

  // Toggle the filter dropdown
  const toggleDropdown = () => setIsDropdownOpen(!isDropdownOpen)

  // Get unique services
  const uniqueServices = [
    ...new Set(customer.CustomerVisits.map(visit => visit.service)),
  ]

  let uniqueSurveyTitles

  if (distributions && distributions.length > 0) {
    uniqueSurveyTitles = [
      ...new Set(distributions.map(dist => dist.survey.title)),
    ]
  }

  // Filter visits based on selected date and service
  const filteredVisits = customer.CustomerVisits.filter(visit => {
    const visitDate = new Date(visit.visitDate)

    // Check if visit date is within the selected date range
    const isDateInRange =
      (!startDate || visitDate >= new Date(startDate)) &&
      (!endDate || visitDate <= new Date(endDate))

    // Check if visit service matches the selected service
    const isServiceMatching =
      !selectedService || visit.service === selectedService

    return isDateInRange && isServiceMatching
  })
  const deleteCustomer = async () => {
    try {
      setLoading(true)
      const response = await axios.delete(
        `${config.backendUrl}/customers?id=${customer.id}`,
        {
          headers: {
            Authorization: `Bearer ${userData.token}`,
          },
        },
      )

      setSuccess(response.data.message)
      setLoading(true)
      props.fetchCustomers()
      setTimeout(() => {
        props.setCustomerDetailsComponentOpened(false)
      }, 2000)
    } catch (err) {
      console.log(err)
      setErr("Error deleting customer")
    }
  }

  const validation = useFormik({
    enableReinitialize: true,
    initialValues: {
      customer: {
        name: props?.customer?.name || "",
        email: props?.customer?.email || "",
        contact: props?.customer?.contact || "",
      },
    },
    validationSchema: Yup.object({
      customer: Yup.object({
        name: Yup.string().required("Please Enter Name"),
        email: Yup.string()
          .email("Invalid Email")
          .required("Please Enter User Email"),
        contact: Yup.string().required("Please Enter Contact"), // Make contact required as well
      }),
    }),
    onSubmit: async values => {
      setLoading(true)
      try {
        const updatedData = { ...values.customer } // Reference customer

        console.log("Updated Data", updatedData)

        const response = await axios.put(
          `${config.backendUrl}/customers/${customer.id}`,
          {
            customer: updatedData,
          },
          {
            headers: {
              Authorization: `Bearer ${userData.token}`,
            },
          },
        )

        console.log("Response: ", response)

        setSuccess(response.data.message)
        setEditTabVisible(false)
        // Add your update logic here (API call, etc.)
      } catch (err) {
        console.error(err) // Log the error for debugging
        setErr("Error Updating Customer")
      } finally {
        setLoading(false) // Stop loading regardless of success or error
      }
    },
  })

  const fetchCustomerSurvey = async () => {
    setLoading(true)
    try {
      const response = await axios.get(
        `${config.backendUrl}/customers/getCustomerSurveys/${customer.id}`,
        {
          headers: {
            Authorization: `Bearer ${userData.token}`,
          },
        },
      )

      if (response.data.distributions.length == 0) {
        setLoading(false)
      } else {
        setDistributions(response.data.distributions)
        setFilteredSurveys(response.data.distributions)
        console.log("response: ", response)
        setLoading(false)
      }
    } catch (err) {
      console.log(err)
      setLoading(false)
    }
  }

  const fetchCustomer = async () => {
    try {
      const response = await axios.get(
        `${config.backendUrl}/customers?customerId=${customer.id}`,
        {
          headers: {
            Authorization: `Bearer ${userData.token}`,
          },
        },
      )

      setCustomer(response.data.customer)
    } catch (err) {
      console.log(err)
      setErr("Error in fetching customer")
    }
  }

  useEffect(() => {
    fetchCustomer()
    fetchCustomerSurvey()
  }, [])

  // scroll simple bar
  const scroollRef = useRef(null)
  return (
    <React.Fragment>
      {editTabVisible ? (
        <EditCustomerCard
          validation={validation}
          err={err}
          success={success}
          setErr={setErr}
          setSuccess={setSuccess}
          setEditTabVisible={setEditTabVisible}
          isLoading={isLoading}
        />
      ) : (
        <div className="d-lg-flex">
          <SnackbarComponent
            err={err}
            success={success}
            setErr={setErr}
            setSuccess={setSuccess}
          />
          <CustomerDetailsLeftCard
            customerDetailsOpened={props.customerDetailsOpened}
            setCustomerDetailsComponentOpened={
              props.setCustomerDetailsComponentOpened
            }
            singleBtn={singleBtn}
            setSingleBtn={setSingleBtn}
            activeTab={activeTab}
            setActiveTab={setActiveTab}
            editTabVisible={editTabVisible}
            setEditTabVisible={setEditTabVisible}
            currentActiveTab={currentActiveTab}
            setCurrentActiveTab={setCurrentActiveTab}
            userJPG={UserJPG}
            deleteCustomer={deleteCustomer}
            customer={customer}
            isLoading={isLoading}
            setLoading={setLoading}
          />
          <CustomerDetailsRightCard
            currentActiveTab={currentActiveTab}
            scroollRef={scroollRef}
            isLoading={isLoading}
            setLoading={setLoading}
            distributions={distributions}
            filteredSurveys={filteredSurveys}
            handleDistributionClick={handleDistributionClick}
            distributionModalOpen={distributionModalOpen}
            toggleModal={toggleModal}
            activeDistribution={activeDistribution}
            filteredVisits={filteredVisits}
          />
        </div>
      )}
    </React.Fragment>
  )
}

export default connect(null, { setBreadcrumbItems })(CustomerDetails)
